import { render, staticRenderFns } from "./VerifyUploadedWill.vue?vue&type=template&id=37df2ce4&scoped=true"
import script from "./VerifyUploadedWill.vue?vue&type=script&lang=js"
export * from "./VerifyUploadedWill.vue?vue&type=script&lang=js"
import style0 from "./VerifyUploadedWill.vue?vue&type=style&index=0&id=37df2ce4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37df2ce4",
  null
  
)

export default component.exports